import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "resource-listing-filter" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-12 col-md-auto col-lg-auto mb-2" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "col-12 col-sm-6 col-md-4 mb-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "" }, " Select Type ", -1 /* HOISTED */)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-12 col-sm-6 col-md-4 mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "" }, " Select Topic ", -1 /* HOISTED */)
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-12 col-md-auto mb-2" }
const _hoisted_12 = {
  key: 0,
  class: "resource-listing-loading"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
  ])
], -1 /* HOISTED */)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "resource-listing-loaded"
}
const _hoisted_16 = { class: "resource-listing-items" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "resource" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = { class: "resource-type" }
const _hoisted_21 = { class: "resource-title" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "resource-link" }
const _hoisted_24 = ["href"]
const _hoisted_25 = ["data-video-vidyard-id", "data-video-title", "aria-label"]
const _hoisted_26 = ["href"]
const _hoisted_27 = {
  key: 0,
  class: "load-more-button"
}
const _hoisted_28 = {
  key: 0,
  class: "resource-listing-no-results"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString($props.filterLabel), 1 /* TEXT */)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.typeFilter) = $event)),
            onChange: _cache[1] || (_cache[1] = (...args) => ($options.initializeDisplayCount && $options.initializeDisplayCount(...args)))
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.typeCategories, (typeCategory) => {
              return (_openBlock(), _createElementBlock("option", {
                key: typeCategory.identifier,
                value: typeCategory.identifier
              }, _toDisplayString(typeCategory.title), 9 /* TEXT, PROPS */, _hoisted_7))
            }), 128 /* KEYED_FRAGMENT */))
          ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
            [_vModelSelect, $data.typeFilter]
          ])
        ], 512 /* NEED_PATCH */), [
          [_vShow, $props.showTypeFilter]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            autocomplete: "off",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.topicFilter) = $event)),
            onChange: _cache[3] || (_cache[3] = (...args) => ($options.initializeDisplayCount && $options.initializeDisplayCount(...args)))
          }, [
            _hoisted_9,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.topicCategories, (topicCategory) => {
              return (_openBlock(), _createElementBlock("option", {
                key: topicCategory.identifier,
                value: topicCategory.identifier
              }, _toDisplayString(topicCategory.title), 9 /* TEXT, PROPS */, _hoisted_10))
            }), 128 /* KEYED_FRAGMENT */))
          ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
            [_vModelSelect, $data.topicFilter]
          ])
        ], 512 /* NEED_PATCH */), [
          [_vShow, $props.showTopicFilter]
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "btn btn-red",
            onClick: _cache[4] || (_cache[4] = (...args) => ($options.resetFilters && $options.resetFilters(...args)))
          }, " Reset ")
        ])
      ])
    ], 512 /* NEED_PATCH */), [
      [_vShow, $props.showTypeFilter || $props.showTopicFilter]
    ]),
    ($data.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredResources.slice(0, $data.displayCount), (resource) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: resource.contentItemId,
                  class: _normalizeClass(["resource-item", { 'resource-item-hide-image': $props.hideImages, 'resource-item-hide-teaser-text': $props.hideTeaserText }])
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    (resource.teaserImage)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "resource-image",
                          src: resource.teaserImage,
                          alt: resource.teaserImageAltText
                        }, null, 8 /* PROPS */, _hoisted_19))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(resource.typeLabel), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("h3", null, _toDisplayString(resource.title), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", {
                      class: "resource-text",
                      innerHTML: resource.teaserText
                    }, null, 8 /* PROPS */, _hoisted_22),
                    _createElementVNode("div", _hoisted_23, [
                      (resource.pageLinkType =='internal' || resource.pageLinkType =='external' && resource.resolvedPageUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "btn btn-arrow-red",
                            href: resource.resolvedPageUrl
                          }, _toDisplayString(resource.ctaLabel), 9 /* TEXT, PROPS */, _hoisted_24))
                        : (resource.pageLinkType =='video' && resource.video)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn btn-arrow-red",
                              type: "button",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#videoModal",
                              "data-video-vidyard-id": resource.video.vidyardId,
                              "data-video-title": resource.video.title,
                              "aria-label": resource.video.title
                            }, _toDisplayString(resource.ctaLabel), 9 /* TEXT, PROPS */, _hoisted_25))
                          : (resource.pageLinkType == 'document' && resource.document)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 2,
                                class: "btn btn-arrow-red",
                                href: resource.document.fileUrl
                              }, _toDisplayString(resource.ctaLabel), 9 /* TEXT, PROPS */, _hoisted_26))
                            : _createCommentVNode("v-if", true)
                    ])
                  ])
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            ($data.displayCount < $options.filteredResources.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-red",
                    onClick: _cache[5] || (_cache[5] = (...args) => ($options.loadMore && $options.loadMore(...args)))
                  }, "Load More")
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          ($options.filteredResources.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _renderSlot(_ctx.$slots, "no-results-message")
              ]))
            : _createCommentVNode("v-if", true)
        ]))
  ], 64 /* STABLE_FRAGMENT */))
}